/**
 * Agent-factory event types for durable event recording (agent-factory:*).
 *
 * NOTE: factory run/conversation lifecycle events (`factory:*`,
 * `conversation:*`) live in `@cluster/agent-core` (FACTORY_EVENTS /
 * CONVERSATION_EVENTS) and are NOT duplicated here — some payloads carry them
 * under `payload.kind` untouched.
 */
export enum AgentFactoryEventType {
  FACTORY_CREATED = 'agent-factory:factory.created',
  FACTORY_UPDATED = 'agent-factory:factory.updated',
  FACTORY_CLONED = 'agent-factory:factory.cloned',
  FACTORY_DELETED = 'agent-factory:factory.deleted',
  FACTORY_DISPATCHED = 'agent-factory:factory.dispatched',
  PROVIDER_CREATED = 'agent-factory:provider.created',
  PROVIDER_UPDATED = 'agent-factory:provider.updated',
  PROVIDER_DELETED = 'agent-factory:provider.deleted',
  PROVIDER_TEST_OK = 'agent-factory:provider.test-ok',
  PROVIDER_TEST_FAILED = 'agent-factory:provider.test-failed',
  MODEL_CREATED = 'agent-factory:model.created',
  MODEL_UPDATED = 'agent-factory:model.updated',
  MODEL_DELETED = 'agent-factory:model.deleted',
  MODEL_TEST_OK = 'agent-factory:model.test-ok',
  MODEL_TEST_FAILED = 'agent-factory:model.test-failed',
  MODEL_COLLECTION_CREATED = 'agent-factory:model-collection.created',
  MODEL_COLLECTION_UPDATED = 'agent-factory:model-collection.updated',
  MODEL_COLLECTION_DELETED = 'agent-factory:model-collection.deleted',
  TRIGGER_CREATED = 'agent-factory:trigger.created',
  TRIGGER_UPDATED = 'agent-factory:trigger.updated',
  TRIGGER_DELETED = 'agent-factory:trigger.deleted',
}

/**
 * Pub/sub channel for agent-factory events.
 */
export const AGENT_FACTORY_EVENTS_CHANNEL = 'agent-factory:events';